import axiosClient from '@/config/api/axios'
import { DOCUMENTS_V2 } from '@/config/api/endpoints'
import { isApiConfigured } from '@/config/api/env'
import { documentFromRow } from './documentMappers'

/**
 * Upload one file into a chat.
 *
 * `idempotencyKey` is required and client-held: it is both the retry handle and
 * the cancellation handle. The server reserves against it before writing bytes,
 * so a replay returns the original document rather than storing a second copy,
 * and a removal can address the upload even when its response never arrived.
 */
export async function uploadChatDocument(file, options = {}) {
  if (!isApiConfigured()) return null
  const form = new FormData()
  form.append('file', file)
  const params = {
    chat_id: options.chatId,
    idempotency_key: options.idempotencyKey,
    ...(options.projectId ? { project_id: options.projectId } : {}),
  }
  const { data } = await axiosClient.post(DOCUMENTS_V2, form, { params, signal: options.signal })
  return documentFromRow(data)
}

/**
 * Remove an upload, by document id once it is known and by key before then.
 *
 * Deleting the document also removes the stored original, so this is the whole
 * cleanup — there is no separate object to sweep.
 */
export async function deleteChatDocument(options = {}) {
  if (!isApiConfigured() || !options.chatId) return
  const params = {
    chat_id: options.chatId,
    ...(options.documentId
      ? { document_id: options.documentId }
      : { idempotency_key: options.idempotencyKey }),
  }
  try {
    await axiosClient.delete(DOCUMENTS_V2, { params })
  } catch {
    /* already gone, or never landed */
  }
}
